export default __webpack_public_path__ + "static/media/kingsale.4f789f3b.png";